import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, withKeys as _withKeys, renderSlot as _renderSlot, vModelCheckbox as _vModelCheckbox, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "rz" }
const _hoisted_2 = { class: "rz-hero" }
const _hoisted_3 = { class: "rz-top" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { viewBox: "0 0 54 54" }
const _hoisted_6 = ["stroke-dasharray"]
const _hoisted_7 = { class: "rz-ttl" }
const _hoisted_8 = { class: "rz-sub" }
const _hoisted_9 = {
  key: 0,
  class: "rz-st warn"
}
const _hoisted_10 = {
  key: 1,
  class: "rz-st"
}
const _hoisted_11 = {
  key: 1,
  class: "rz-st ok"
}
const _hoisted_12 = {
  key: 0,
  class: "rz-stack",
  "aria-hidden": "true"
}
const _hoisted_13 = ["title"]
const _hoisted_14 = {
  key: 0,
  class: "rz-av more"
}
const _hoisted_15 = ["aria-expanded"]
const _hoisted_16 = {
  key: 1,
  class: "rz-signlist"
}
const _hoisted_17 = { class: "rp-scroll" }
const _hoisted_18 = { class: "rp-av" }
const _hoisted_19 = { class: "rp-pmain" }
const _hoisted_20 = { class: "rp-pn" }
const _hoisted_21 = {
  key: 0,
  class: "rp-ps"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["src", "alt"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 0,
  class: "rp-empty"
}
const _hoisted_27 = { class: "rz-ttl" }
const _hoisted_28 = { class: "rz-sub" }
const _hoisted_29 = {
  key: 0,
  class: "rz-why"
}
const _hoisted_30 = {
  key: 1,
  class: "rz-done"
}
const _hoisted_31 = {
  key: 0,
  class: "rz-why"
}
const _hoisted_32 = ["aria-expanded"]
const _hoisted_33 = { class: "rz-n" }
const _hoisted_34 = ["aria-expanded"]
const _hoisted_35 = { class: "rz-n" }
const _hoisted_36 = ["aria-expanded"]
const _hoisted_37 = { class: "rz-n sm" }
const _hoisted_38 = {
  key: 0,
  class: "rz-panel"
}
const _hoisted_39 = {
  key: 0,
  class: "rp-scroll"
}
const _hoisted_40 = { class: "rp-pmain" }
const _hoisted_41 = ["href"]
const _hoisted_42 = ["aria-label", "onClick"]
const _hoisted_43 = {
  key: 1,
  class: "rp-empty"
}
const _hoisted_44 = {
  key: 2,
  class: "rp-addfile"
}
const _hoisted_45 = {
  key: 1,
  class: "rz-panel"
}
const _hoisted_46 = {
  class: "rp-scroll",
  ref: "commentList"
}
const _hoisted_47 = { class: "rp-av" }
const _hoisted_48 = { class: "rp-pmain" }
const _hoisted_49 = { class: "rp-ch" }
const _hoisted_50 = ["innerHTML"]
const _hoisted_51 = { class: "rp-compose" }
const _hoisted_52 = { class: "rp-cf" }
const _hoisted_53 = {
  key: 2,
  class: "rz-panel"
}
const _hoisted_54 = { class: "rp-scroll" }
const _hoisted_55 = {
  key: 0,
  viewBox: "0 0 24 24"
}
const _hoisted_56 = {
  key: 1,
  viewBox: "0 0 24 24"
}
const _hoisted_57 = {
  key: 2,
  viewBox: "0 0 24 24"
}
const _hoisted_58 = { class: "rp-pmain" }
const _hoisted_59 = { class: "rp-hw" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = {
  key: 0,
  class: "rp-hnote"
}
const _hoisted_62 = { class: "rp-ps" }
const _hoisted_63 = {
  key: 0,
  class: "rp-empty"
}
const _hoisted_64 = { class: "rp-av" }
const _hoisted_65 = {
  key: 1,
  class: "rz-after"
}
const _hoisted_66 = {
  key: 2,
  class: "error-msg-wrap"
}
const _hoisted_67 = { class: "form-wrapper slide-up rz-sign-modal" }
const _hoisted_68 = { class: "form-close" }
const _hoisted_69 = {
  key: 0,
  class: "rz-err"
}
const _hoisted_70 = { class: "rt-ack" }
const _hoisted_71 = { class: "rz-attest" }
const _hoisted_72 = { class: "sp-top" }
const _hoisted_73 = { class: "sp-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drop_file = _resolveComponent("drop-file")!
  const _component_VueSignaturePad = _resolveComponent("VueSignaturePad")!
  const _component_sign_off_cells = _resolveComponent("sign-off-cells")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!

  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass(_ctx.collapsed ? 'rec-rail rec-rail-collapsed' : 'rec-rail'),
    "aria-label": "Sign-offs, files, comments"
  }, [
    (_ctx.collapsed)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "rz-toggle rz-show",
          title: "Show sign-offs, files and comments",
          "aria-label": "Show sign-offs, files and comments",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCollapsed(false)))
        }, [...(_cache[27] || (_cache[27] = [
          _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
            _createElementVNode("rect", {
              x: "3",
              y: "4",
              width: "18",
              height: "16",
              rx: "2"
            }),
            _createElementVNode("path", { d: "M15 4v16M10 10l-2 2 2 2" })
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        type: "button",
        class: "rz-toggle rz-hide",
        title: "Hide",
        "aria-label": "Hide sign-offs, files and comments",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCollapsed(true)))
      }, [...(_cache[28] || (_cache[28] = [
        _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
          _createElementVNode("rect", {
            x: "3",
            y: "4",
            width: "18",
            height: "16",
            rx: "2"
          }),
          _createElementVNode("path", { d: "M15 4v16M8 10l2 2-2 2" })
        ], -1)
      ]))]),
      _createElementVNode("section", _hoisted_2, [
        (_ctx.isAdmin)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.signedCount == _ctx.required.length && _ctx.required.length ? 'rz-ring ok' : 'rz-ring'),
                  role: "img",
                  "aria-label": _ctx.signedCount + ' of ' + _ctx.required.length + ' signed'
                }, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_5, [
                    _cache[29] || (_cache[29] = _createElementVNode("circle", {
                      cx: "27",
                      cy: "27",
                      r: "22",
                      class: "trk"
                    }, null, -1)),
                    _createElementVNode("circle", {
                      cx: "27",
                      cy: "27",
                      r: "22",
                      class: "bar",
                      "stroke-dasharray": _ctx.ringDash
                    }, null, 8, _hoisted_6)
                  ])),
                  _createElementVNode("span", null, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.signedCount), 1),
                    _createTextVNode("/" + _toDisplayString(_ctx.required.length), 1)
                  ])
                ], 10, _hoisted_4),
                _createElementVNode("div", _hoisted_7, [
                  _cache[33] || (_cache[33] = _createElementVNode("h3", null, "Sign-offs", -1)),
                  _createElementVNode("div", _hoisted_8, "on version " + _toDisplayString(_ctx.version), 1),
                  (_ctx.groups.stale.length || _ctx.groups.none.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.groups.stale.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _cache[30] || (_cache[30] = _createElementVNode("i", null, null, -1)),
                              _createTextVNode(_toDisplayString(_ctx.groups.stale.length) + " need to sign again", 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.groups.none.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _cache[31] || (_cache[31] = _createElementVNode("i", null, null, -1)),
                              _createTextVNode(_toDisplayString(_ctx.groups.none.length) + " haven't signed", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_ctx.required.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[32] || (_cache[32] = [
                          _createElementVNode("i", null, null, -1),
                          _createTextVNode("Everyone has signed", -1)
                        ]))]))
                      : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.pending.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pending.slice(0, 5), (p) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: p.key,
                        class: _normalizeClass(p.latest ? 'rz-av stale' : 'rz-av'),
                        title: p.name
                      }, _toDisplayString(_ctx.initials(p.name)), 11, _hoisted_13))
                    }), 128)),
                    (_ctx.pending.length > 5)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, "+" + _toDisplayString(_ctx.pending.length - 5), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _cache[35] || (_cache[35] = _createElementVNode("div", {
                class: "rz-why",
                style: {"text-align":"left"}
              }, "Admins don't sign. To sign off, switch to your Standard User account using the toggle at the top.", -1)),
              _createElementVNode("button", {
                type: "button",
                class: "rz-link",
                "aria-expanded": _ctx.open == 'sign',
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggle('sign')))
              }, [
                _createTextVNode(_toDisplayString(_ctx.open == 'sign' ? 'Hide' : "See who's signed") + " ", 1),
                (_openBlock(), _createElementBlock("svg", {
                  viewBox: "0 0 24 24",
                  class: _normalizeClass(_ctx.open == 'sign' ? 'rz-chev up' : 'rz-chev')
                }, [...(_cache[34] || (_cache[34] = [
                  _createElementVNode("path", { d: "M6 9l6 6 6-6" }, null, -1)
                ]))], 2))
              ], 8, _hoisted_15),
              (_ctx.open == 'sign')
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signGroups, (group) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: group.id,
                        class: "rp-group"
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass('rp-gh ' + group.cls)
                        }, [
                          _createElementVNode("span", null, [
                            _createTextVNode(_toDisplayString(group.title) + " ", 1),
                            _createElementVNode("b", null, _toDisplayString(group.people.length), 1)
                          ])
                        ], 2),
                        _createElementVNode("div", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.expanded[group.id] ? group.people : group.people.slice(0, 4)), (p) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: p.key,
                              class: "rp-person"
                            }, [
                              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.initials(p.name)), 1),
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, _toDisplayString(p.name), 1),
                                (p.latest)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                      (!_ctx.isCurrent(p.latest))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Signed an earlier version · "))
                                        : _createCommentVNode("", true),
                                      _createTextVNode(_toDisplayString(_ctx.fmtDay(p.latest.Date)), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.cellSignOffs, (s, j) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: j,
                                    class: "rp-ps"
                                  }, [
                                    _createElementVNode("a", {
                                      onClick: _withModifiers(($event: any) => (_ctx.showSignOffCells(s)), ["prevent"])
                                    }, _toDisplayString(s.SeatName), 9, _hoisted_23),
                                    _createTextVNode(" · " + _toDisplayString(_ctx.fmtDay(s.Date)), 1)
                                  ]))
                                }), 128))
                              ]),
                              (p.latest && p.latest.SignatureData)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    class: "sp-thumb",
                                    src: p.latest.SignatureData,
                                    alt: 'Signature of ' + p.name
                                  }, null, 8, _hoisted_24))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]),
                        (group.people.length > 4)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "rp-more",
                              onClick: ($event: any) => (_ctx.expanded[group.id] = !_ctx.expanded[group.id])
                            }, _toDisplayString(_ctx.expanded[group.id] ? 'Show less' : 'Show all ' + group.people.length), 9, _hoisted_25))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    (!_ctx.required.length && !_ctx.unassigned.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_26, "No standard users can view this yet, so no one is asked to sign it."))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_27, [
                _cache[36] || (_cache[36] = _createElementVNode("h3", null, "Sign-off", -1)),
                _createElementVNode("div", _hoisted_28, "Version " + _toDisplayString(_ctx.version), 1)
              ]),
              (_ctx.node && _ctx.node.NeedsApproval)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, "This isn't published, so it can't be signed until it is."))
                : (_ctx.myStatus == 'current')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _cache[37] || (_cache[37] = _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                        _createElementVNode("path", { d: "M5 12.5l4.5 4.5L19 7.5" })
                      ], -1)),
                      _createTextVNode(" You signed v" + _toDisplayString(_ctx.version) + " · " + _toDisplayString(_ctx.fmtDay(_ctx.myLatest.Date)), 1)
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "rz-sign",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openSign()))
                      }, [
                        _cache[38] || (_cache[38] = _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                          _createElementVNode("path", { d: "M3 17c3-1 4-6 6-6s-1 6 1 6 3-3 4-3 1 3 3 3h4M3 21h18" })
                        ], -1)),
                        _createTextVNode(" Sign off on v" + _toDisplayString(_ctx.version), 1)
                      ]),
                      (_ctx.myStatus == 'stale')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, "You signed on " + _toDisplayString(_ctx.fmtDay(_ctx.myLatest.Date)) + ". It's changed since.", 1))
                        : _createCommentVNode("", true)
                    ], 64))
            ], 64))
      ]),
      _createElementVNode("div", {
        class: "rz-tabs",
        style: _normalizeStyle('grid-template-columns:repeat(' + (_ctx.isAdmin ? 3 : 2) + ',1fr)')
      }, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(_ctx.open == 'files' ? 'rz-tab on' : 'rz-tab'),
          "aria-expanded": _ctx.open == 'files',
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggle('files')))
        }, [
          _cache[39] || (_cache[39] = _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
            _createElementVNode("path", { d: "M15 7l-6.5 6.5a1.5 1.5 0 0 0 3 3L18 10a3 3 0 0 0-6-6l-6.5 6.5a4.5 4.5 0 0 0 9 9L21 13" })
          ], -1)),
          _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.files.length), 1),
          _cache[40] || (_cache[40] = _createElementVNode("span", { class: "rz-l" }, "Files", -1))
        ], 10, _hoisted_32),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(_ctx.open == 'cmts' ? 'rz-tab on' : 'rz-tab'),
          "aria-expanded": _ctx.open == 'cmts',
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggle('cmts')))
        }, [
          _cache[41] || (_cache[41] = _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
            _createElementVNode("path", { d: "M8 9h8M8 13h6M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-5l-5 3v-3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h12z" })
          ], -1)),
          _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.comments.length), 1),
          _cache[42] || (_cache[42] = _createElementVNode("span", { class: "rz-l" }, "Comments", -1))
        ], 10, _hoisted_34),
        (_ctx.isAdmin)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: _normalizeClass(_ctx.open == 'hist' ? 'rz-tab on' : 'rz-tab'),
              "aria-expanded": _ctx.open == 'hist',
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggle('hist')))
            }, [
              _cache[43] || (_cache[43] = _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                _createElementVNode("path", { d: "M12 8v4l2 2M3.05 11a9 9 0 1 1 .5 4M3 4v5h5" })
              ], -1)),
              _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.logs.length ? _ctx.fmtDay(_ctx.logs[0].Date) : '—'), 1),
              _cache[44] || (_cache[44] = _createElementVNode("span", { class: "rz-l" }, "History", -1))
            ], 10, _hoisted_36))
          : _createCommentVNode("", true)
      ], 4),
      (_ctx.open == 'files')
        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
            (_ctx.files.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: file.ID,
                      class: "rp-file"
                    }, [
                      _cache[46] || (_cache[46] = _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                        _createElementVNode("path", { d: "M14 3v4a1 1 0 0 0 1 1h4M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2z" })
                      ], -1)),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("a", {
                          class: "rp-fn",
                          href: _ctx.fileUrl(file),
                          target: "_blank",
                          rel: "noopener"
                        }, _toDisplayString(file.Name), 9, _hoisted_41)
                      ]),
                      (_ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "rp-x",
                            "aria-label": 'Remove ' + file.Name,
                            onClick: ($event: any) => (_ctx.fileToDelete = file.ID)
                          }, [...(_cache[45] || (_cache[45] = [
                            _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                              _createElementVNode("path", { d: "M18 6L6 18M6 6l12 12" })
                            ], -1)
                          ]))], 8, _hoisted_42))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (!_ctx.files.length && !_ctx.isAdmin)
              ? (_openBlock(), _createElementBlock("p", _hoisted_43, "No files yet."))
              : _createCommentVNode("", true),
            (_ctx.isAdmin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.fileName) = $event)),
                    placeholder: "File name",
                    "aria-label": "File name"
                  }, null, 512), [
                    [_vModelText, _ctx.fileName]
                  ]),
                  (_openBlock(), _createBlock(_component_drop_file, {
                    key: _ctx.dropKey,
                    onFileChange: _cache[8] || (_cache[8] = (f) => { _ctx.file = f })
                  })),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(_ctx.busy ? 'btn disable-button' : 'btn'),
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.uploadFile()))
                  }, "Add file", 2)
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_ctx.open == 'cmts')
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commentsOldestFirst, (comment, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "rp-cmt"
                  }, [
                    _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.initials(comment.User)), 1),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("b", null, _toDisplayString(comment.User), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.ago(comment.Date)), 1)
                      ]),
                      _createElementVNode("div", {
                        class: "rp-ct",
                        innerHTML: comment.CommentDisplay
                      }, null, 8, _hoisted_50)
                    ])
                  ]))
                }), 128))
              ], 512),
              _createElementVNode("div", _hoisted_51, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.commentInput) = $event)),
                  ref: "commentInput",
                  placeholder: "Add a comment. Type @ and a name or email to notify someone.",
                  "aria-label": "Add a comment",
                  onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.checkCommentInput())),
                  onKeydown: _cache[12] || (_cache[12] = _withKeys(_withModifiers(($event: any) => (_ctx.submitComment()), ["exact","prevent"]), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.commentInput]
                ]),
                (_ctx.userAutoFill)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "rp-autofill",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setUserAutoFill()))
                    }, _toDisplayString(_ctx.userAutoFill.Name ? _ctx.userAutoFill.Name + ' · ' : '') + _toDisplayString(_ctx.userAutoFill.Email), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_52, [
                  _cache[47] || (_cache[47] = _createElementVNode("span", null, "Enter to post", -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(_ctx.busy ? 'btn disable-button' : 'btn'),
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.submitComment()))
                  }, "Post", 2)
                ])
              ])
            ]))
          : (_ctx.open == 'hist' && _ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.histAll ? _ctx.historyRows : _ctx.historyRows.slice(0, 6)), (log, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: _normalizeClass('rp-hrow ' + log.kind)
                    }, [
                      _createElementVNode("i", null, [
                        (log.kind == 'review')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_55, [...(_cache[48] || (_cache[48] = [
                              _createElementVNode("path", { d: "M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" }, null, -1),
                              _createElementVNode("circle", {
                                cx: "12",
                                cy: "12",
                                r: "3"
                              }, null, -1)
                            ]))]))
                          : (log.kind == 'approve')
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_56, [...(_cache[49] || (_cache[49] = [
                                _createElementVNode("path", { d: "M5 12.5l4.5 4.5L19 7.5" }, null, -1)
                              ]))]))
                            : (_openBlock(), _createElementBlock("svg", _hoisted_57, [...(_cache[50] || (_cache[50] = [
                                _createElementVNode("path", { d: "M4 20h4L18.5 9.5a2.83 2.83 0 0 0-4-4L4 16v4M13.5 6.5l4 4" }, null, -1)
                              ]))]))
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("b", null, _toDisplayString(log.User), 1),
                          _createTextVNode(" " + _toDisplayString(log.action), 1),
                          (log.count > 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_60, " (" + _toDisplayString(log.count) + "×)", 1))
                            : _createCommentVNode("", true)
                        ]),
                        (log.note)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_61, "“" + _toDisplayString(log.note) + "”", 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.fmtWhen(log.Date)), 1)
                      ])
                    ], 2))
                  }), 128))
                ]),
                (!_ctx.historyRows.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_63, "No history yet."))
                  : _createCommentVNode("", true),
                (_ctx.historyRows.length > 6)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "rp-more",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.histAll = !_ctx.histAll))
                    }, _toDisplayString(_ctx.histAll ? 'Show less' : 'Show all ' + _ctx.historyRows.length), 1))
                  : _createCommentVNode("", true)
              ]))
            : (_ctx.comments.length)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  type: "button",
                  class: "rz-peek",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.toggle('cmts')))
                }, [
                  _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.initials(_ctx.comments[0].User)), 1),
                  _createElementVNode("span", null, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.comments[0].User.split(' ')[0]), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.stripHtml(_ctx.comments[0].Comment)), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
    ]),
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSign)
      ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("button", {
                type: "button",
                class: "form-close-x",
                title: "Close",
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showSign = false))
              }, "×")
            ]),
            _createElementVNode("h3", null, "Sign off on v" + _toDisplayString(_ctx.version), 1),
            (_ctx.signError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_69, _toDisplayString(_ctx.signError), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_70, [
              _cache[51] || (_cache[51] = _createTextVNode("By signing, you confirm you understand ", -1)),
              _createElementVNode("b", null, _toDisplayString(_ctx.nodeName), 1),
              _createTextVNode(" (v" + _toDisplayString(_ctx.version) + "), you'll follow it as part of supporting our team's success, and you'll tell management when it can be improved.", 1)
            ]),
            _createElementVNode("label", _hoisted_71, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.signAttest) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.signAttest]
              ]),
              _cache[52] || (_cache[52] = _createElementVNode("span", null, "I've read this version of the process.", -1))
            ]),
            _createElementVNode("div", _hoisted_72, [
              _cache[53] || (_cache[53] = _createElementVNode("span", { class: "rz-lbl" }, "Sign here", -1)),
              _createElementVNode("a", {
                onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => ((_ctx.$refs as any).signaturePad.clearSignature()), ["prevent"]))
              }, "Clear")
            ]),
            _createElementVNode("div", _hoisted_73, [
              _createVNode(_component_VueSignaturePad, { ref: "signaturePad" }, null, 512)
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.signatureInput) = $event)),
              placeholder: "Type your name",
              "aria-label": "Your name",
              style: {"margin-top":"15px"}
            }, null, 512), [
              [_vModelText, _ctx.signatureInput]
            ]),
            _createElementVNode("input", {
              class: _normalizeClass(_ctx.busy ? 'disable-button' : ''),
              type: "submit",
              value: "Sign",
              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.submitSignature()))
            }, null, 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.signOffToShow)
      ? (_openBlock(), _createBlock(_component_sign_off_cells, {
          key: 3,
          signOff: _ctx.signOffToShow,
          onClose: _cache[22] || (_cache[22] = ($event: any) => (_ctx.signOffToShow = null))
        }, null, 8, ["signOff"]))
      : _createCommentVNode("", true),
    (_ctx.outsideTags.length)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 4,
          onConfirm: _cache[23] || (_cache[23] = ($event: any) => (_ctx.submitComment(_ctx.outsideTags))),
          onCancel: _cache[24] || (_cache[24] = ($event: any) => (_ctx.outsideTags = [])),
          msg: _ctx.outsideMessage
        }, null, 8, ["msg"]))
      : _createCommentVNode("", true),
    (_ctx.fileToDelete)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 5,
          onConfirm: _cache[25] || (_cache[25] = ($event: any) => (_ctx.deleteFile())),
          onCancel: _cache[26] || (_cache[26] = ($event: any) => (_ctx.fileToDelete = null)),
          msg: "Are you sure you would like to delete this file?"
        }))
      : _createCommentVNode("", true)
  ], 2))
}